import { render, staticRenderFns } from "./AvatarForm.vue?vue&type=template&id=609711aa&scoped=true&"
import script from "./AvatarForm.vue?vue&type=script&lang=js&"
export * from "./AvatarForm.vue?vue&type=script&lang=js&"
import style0 from "./AvatarForm.vue?vue&type=style&index=0&id=609711aa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "609711aa",
  null
  
)

export default component.exports